import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  ListGroup,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  createPassport,
  resetPassportCreate,
} from "../features/passport/passportSlice";
import { getAllOffices } from "../features/deliveryoffice/officeSlice";
import { getAllAgents } from "../features/agent/agentSlice";
import { getAllEmployees } from "../features/employee/employeeSlice";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import { FaFilePdf, FaFileWord } from "react-icons/fa6";
import { logout } from "../features/user/userSlice";

const CreatePassport = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();

  //For preview image
  const [selectedImage, setSelectedImage] = useState(null);

  // Passport states
  const [passportScanCopy, setPassportScanCopy] = useState("");
  const [name, setName] = useState("");
  const [passportNumber, setPassportNumber] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [DOB, setDOB] = useState("");
  const [age, setAge] = useState("");
  const [doIssue, setDOissue] = useState("");
  const [receiveDate, setReceiveDate] = useState("");
  const [country, setCountry] = useState("");
  const [company, setCompany] = useState("");
  const [post, setPost] = useState("");
  const [agent, setAgent] = useState("");
  const [officeAgent, setOfficeAgent] = useState("");
  const [initialContract, setInitialContract] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [contract, setContract] = useState("");
  const [amountPaid, setAmountPaid] = useState(0);
  const [dueAmount, setDueAmount] = useState(0);
  const [deliveryOffice, setDeliveryOffice] = useState("");
  const [deliveryOfficePayment, setDeliveryOfficePayment] = useState(0);
  const [status, setStatus] = useState("");

  const [deliveryOffices, setDeliveryOffices] = useState([]);
  const [allAgents, setAllAgents] = useState([]);
  const [allEmployees, setAllEmployees] = useState([]);

  const { userInfo } = useSelector((state) => state.user);

  const {
    passport,
    isCreateLoading,
    isCreateSuccess,
    isCreateError,
    createErrorMessage,
  } = useSelector((state) => state.passport);

  const {
    offices,
    isListLoading,
    isListError,
    isListSuccess,
    listErrorMessage,
  } = useSelector((state) => state.office);

  const {
    agents,
    isListLoading: isAgentListLoading,
    isListError: isAgentListError,
    isListSuccess: isAgentListSuccess,
    listErrorMessage: agentListErrorMessage,
  } = useSelector((state) => state.agent);

  const {
    employees,
    isListLoading: isEmployeeListLoading,
    isListError: isEmployeeListError,
    isListSuccess: isEmployeeListSuccess,
    listErrorMessage: employeeListErrorMessage,
  } = useSelector((state) => state.employee);

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login To Get Access!!", { position: "top-center" });
      navigate("/login");
    }
    if (userInfo.permissions?.includes("createPassport") === false) {
      toast.error("Paknami Keno Koren???", {
        position: "top-center",
      });
      dispatch(logout());
    }
  }, [userInfo, navigate, dispatch]);

  // Delivery Offices List
  useEffect(() => {
    if (isListError) {
      // toast.error(listErrorMessage, { position: "top-center" });
    } else if (isListSuccess) {
      // return offices;
      setDeliveryOffices(offices);
    } else {
      dispatch(getAllOffices());
    }
  }, [dispatch, isListError, isListSuccess, offices]);

  // Agents List
  useEffect(() => {
    if (isAgentListError) {
      // toast.error(agentListErrorMessage, { position: "top-center" });
    } else if (isAgentListSuccess) {
      setAllAgents(agents);
    } else {
      dispatch(getAllAgents());
    }
  }, [
    dispatch,
    isAgentListError,
    isAgentListSuccess,
    // agentListErrorMessage,
    agents,
  ]);

  // Employees List
  useEffect(() => {
    if (isEmployeeListError) {
      // toast.error(employeeListErrorMessage, { position: "top-center" });
    } else if (isEmployeeListSuccess) {
      setAllEmployees(employees);
    } else {
      dispatch(getAllEmployees());
    }
  }, [
    dispatch,
    isEmployeeListError,
    isEmployeeListSuccess,
    // employeeListErrorMessage,
    employees,
  ]);

  useEffect(() => {
    if (isCreateSuccess) {
      toast.success("Passport Created Successfully", {
        position: "top-center",
      });
      navigate("/passportList");
    } else if (isCreateError) {
      toast.error(createErrorMessage, {
        position: "top-center",
      });
    }
  }, [isCreateSuccess, isCreateError, createErrorMessage, navigate, passport]);

  const handleDeliveryOfficeSelect = (e) => {
    if (e.target.value !== "") {
      // setSelectedDeliveryOffice(e.target.value);
      setDeliveryOffice(e.target.value);
    } else {
      setDeliveryOffice("");
    }
  };

  const handleAgentSelect = (e) => {
    if (e.target.value !== "") {
      setAgent(e.target.value);
    } else {
      setAgent("");
    }
  };

  const handleEmployeeSelect = (e) => {
    if (e.target.value !== "") {
      setOfficeAgent(e.target.value);
    } else {
      setOfficeAgent("");
    }
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (
      name !== "" &&
      passportNumber !== "" &&
      phone !== "" &&
      email !== "" &&
      doIssue !== "" &&
      receiveDate !== "" &&
      status !== ""
    ) {
      dispatch(
        createPassport({
          passportScanCopy: passportScanCopy,
          fullName: name,
          passportNumber: passportNumber,
          phone: phone,
          email: email,
          address: address,
          dateOfBirth: DOB,
          age: age,
          doIssueDate: doIssue,
          passportReceiveDate: receiveDate,
          country: country,
          company: company,
          clientPost: post,
          agent: agent,
          officeAgent: officeAgent,
          initialContract: initialContract,
          discount: discount,
          contractAmount: contract,
          paidAmount: amountPaid,
          dueAmount: dueAmount,
          deliveryOffice: deliveryOffice,
          deliveryOfficePayment: deliveryOfficePayment,
          status,
        })
      );
    } else {
      toast.error("Please fill all required fields", {
        position: "top-center",
      });
    }
  };

  // Contract Amount Calculation with Discount
  useEffect(() => {
    setContract(initialContract * 1 - discount * 1);
  }, [initialContract, discount]);

  const [documentName, setDocumentName] = useState("");
  const [documentType, setDocumentType] = useState("");

  const uploadDocumentFileHandler = async (event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("document", file);
    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await axios.post(
        `/api/v1/uploadDocument${
          passportScanCopy ? `/${passportScanCopy.slice(8)}` : ""
        }`,
        formData,
        config
      );
      setPassportScanCopy(data);
    } catch (error) {
      console.error(error);
    }

    if (file) {
      setDocumentName(file.name);

      const extension = file.name.split(".").pop().toLowerCase();

      if (extension === "pdf") {
        setDocumentType("PDF");
      } else if (extension === "doc" || extension === "docx") {
        setDocumentType("DOC");
      } else {
        setDocumentType("File");
      }
    }
  };

  let icon = null;
  if (documentType === "PDF") {
    icon = <FaFilePdf size={100} style={{ color: "red" }} />;
  } else if (documentType === "DOC") {
    icon = <FaFileWord size={100} style={{ color: "blue" }} />;
  }

  useEffect(() => {
    return () => {
      dispatch(resetPassportCreate());
    };
  }, []);

  return (
    <Container fluid className="my-4">
      <Row className="mb-4">
        <Card
          className="rounded-4 border"
          style={{ backgroundColor: "#e6edf1" }}
        >
          <h2 className="text-center text-dark fw-bold my-3">
            Create <span style={{ color: "#5c91dc" }}>Passport</span>
          </h2>
        </Card>
      </Row>
      <>
        {isCreateLoading ? (
          <Loader />
        ) : (
          <Form onSubmit={submitHandler}>
            <Row>
              {/* Column for Upload Files  */}
              <Col sm={12} md={4} lg={3}>
                <Card
                  className="mb-4 shadow rounded"
                  style={{ minHeight: "20vh" }}
                >
                  <Card.Header
                    className="text-black text-center fw-bold p-3"
                    style={{ backgroundColor: "#74a2e3" }}
                    as="h5"
                  >
                    Document Scan Copy
                  </Card.Header>

                  <Card.Body className="text-center">
                    <ListGroup variant="flush">
                      {/* Upload the Document with Preview */}
                      <ListGroup.Item>
                        <Form.Group controlId="document">
                          {icon && <div className="my-3">{icon}</div>}
                          <Form.Control
                            className="mb-3 rounded"
                            type="file"
                            id="document"
                            label="Passport Scan Copy"
                            controlId="passportScanCopy"
                            onChange={uploadDocumentFileHandler}
                          />
                          {documentName && (
                            <div className="mt-3">
                              <h6>Document Type: {documentType}</h6>
                              <h6>Document Name: {documentName}</h6>
                            </div>
                          )}
                        </Form.Group>

                        <div className="small font-italic text-muted">
                          DOC, DOCX, PDF
                        </div>
                      </ListGroup.Item>
                    </ListGroup>
                  </Card.Body>
                </Card>
              </Col>

              <Col sm={12} md={8} lg={9}>
                <Card className="mb-4 shadow rounded">
                  <Card.Header
                    as="h5"
                    className="text-black text-center fw-bold p-3"
                    style={{ backgroundColor: "#74a2e3" }}
                  >
                    Passport Information
                  </Card.Header>

                  <Card.Body className="fw-bold">
                    <Row>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="name">
                          <Form.Label style={{ color: "black" }}>
                            Full Name
                          </Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Full Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="passportNumber">
                          <Form.Label style={{ color: "black" }}>
                            Passport Number
                          </Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Passport Number"
                            value={passportNumber}
                            onChange={(e) => setPassportNumber(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="phone">
                          <Form.Label style={{ color: "black" }}>
                            Phone No.
                          </Form.Label>
                          <Form.Control
                            required
                            type="text"
                            placeholder="Enter Phone Number"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="email">
                          <Form.Label style={{ color: "black" }}>
                            Email Address
                          </Form.Label>
                          <Form.Control
                            required
                            type="mail"
                            placeholder="Enter Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col sm={12} md={12} lg={12}>
                        <Form.Group controlId="address">
                          <Form.Label style={{ color: "black" }}>
                            Address
                          </Form.Label>
                          <Form.Control
                            // required
                            type="text"
                            placeholder="Enter Address"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="DOB">
                          <Form.Label style={{ color: "black" }}>
                            Date Of Birth
                          </Form.Label>
                          <Form.Control
                            // required
                            type="date"
                            placeholder="Select Date of Birth"
                            value={DOB}
                            onChange={(e) => setDOB(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="age">
                          <Form.Label style={{ color: "black" }}>
                            Age
                          </Form.Label>
                          <Form.Control
                            // required
                            type="number"
                            disabled
                            placeholder="Calculate Automatically"
                            value={age}
                            onChange={(e) => setAge(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="doIssue">
                          <Form.Label style={{ color: "black" }}>
                            DO Issue
                          </Form.Label>
                          <Form.Control
                            required
                            type="date"
                            placeholder="Select Issue Date"
                            value={doIssue}
                            onChange={(e) => setDOissue(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="receiveDate">
                          <Form.Label style={{ color: "black" }}>
                            Receive Date
                          </Form.Label>
                          <Form.Control
                            required
                            type="date"
                            placeholder="Select Delivery Date"
                            value={receiveDate}
                            onChange={(e) => setReceiveDate(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col sm={12} md={4} lg={4}>
                        <Form.Group controlId="country">
                          <Form.Label style={{ color: "black" }}>
                            Country
                          </Form.Label>
                          <Form.Control
                            // required
                            type="text"
                            placeholder="Country Name"
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={4} lg={4}>
                        <Form.Group controlId="company">
                          <Form.Label style={{ color: "black" }}>
                            Company
                          </Form.Label>
                          <Form.Control
                            // required
                            type="text"
                            placeholder="Company Name"
                            value={company}
                            onChange={(e) => setCompany(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={4} lg={4}>
                        <Form.Group controlId="post">
                          <Form.Label style={{ color: "black" }}>
                            Post
                          </Form.Label>
                          <Form.Control
                            // required
                            type="text"
                            placeholder="Post"
                            value={post}
                            onChange={(e) => setPost(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="agent">
                          <Form.Label style={{ color: "black" }}>
                            Agent Name
                          </Form.Label>
                          <Form.Select
                            as="select"
                            value={agent}
                            onChange={(e) => handleAgentSelect(e)}
                          >
                            <option value="" disabled>
                              Select Agent
                            </option>

                            {allAgents &&
                              allAgents.map((agent) => (
                                <option key={agent._id} value={agent.fullName}>
                                  {agent.fullName}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="officeAgent">
                          <Form.Label style={{ color: "black" }}>
                            Select Employee
                          </Form.Label>
                          <Form.Select
                            as="select"
                            value={officeAgent}
                            onChange={(e) => handleEmployeeSelect(e)}
                          >
                            <option value="" disabled>
                              Select Employee
                            </option>

                            {allEmployees &&
                              allEmployees.map((employee) => (
                                <option
                                  key={employee._id}
                                  value={employee.fullName}
                                >
                                  {employee.fullName}
                                </option>
                              ))}
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mt-3">
                      <Col sm={12} md={4} lg={4}>
                        <Form.Group controlId="c">
                          <Form.Label style={{ color: "black" }}>
                            Initial Contract Amount
                          </Form.Label>
                          <Form.Control
                            required
                            type="number"
                            placeholder="Initial Contract Amount"
                            value={initialContract}
                            onChange={(e) => setInitialContract(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={4} lg={4}>
                        <Form.Group controlId="c">
                          <Form.Label style={{ color: "black" }}>
                            Discount Amount
                          </Form.Label>
                          <Form.Control
                            // required
                            type="number"
                            placeholder="Discount Amount"
                            value={discount}
                            onChange={(e) => setDiscount(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={4} lg={4}>
                        <Form.Group controlId="c">
                          <Form.Label style={{ color: "black" }}>
                            Contract Amount
                          </Form.Label>
                          <Form.Control
                            // required
                            disabled
                            type="number"
                            placeholder="Will Be Calculated Automatically"
                            value={contract}
                            onChange={(e) => setContract(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                      {/* <Col sm={12} md={4} lg={4}>
                        <Form.Group controlId="amountPaid">
                          <Form.Label
                            style={{  color: "black" }}
                          >
                            Amount Paid
                          </Form.Label>
                          <Form.Control
                            // required
                            type="number"
                            placeholder="Amount Paid"
                            value={amountPaid}
                            onChange={(e) => setAmountPaid(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col> */}
                      {/* <Col sm={12} md={4} lg={4}>
                        <Form.Group controlId="dueAmount">
                          <Form.Label
                            style={{ color: "black" }}
                          >
                            Due Amount
                          </Form.Label>
                          <Form.Control
                            disabled
                            type="text"
                            placeholder="Calculated Automatically"
                            value={dueAmount}
                            onChange={(e) => setDueAmount(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col> */}
                    </Row>
                    <Row className="mt-3">
                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="deliveryOffice">
                          <Form.Label style={{ color: "black" }}>
                            Delivery Office
                          </Form.Label>

                          <Form.Control
                            as="select"
                            value={deliveryOffice}
                            onChange={(e) => handleDeliveryOfficeSelect(e)}
                          >
                            <option value="" disabled>
                              Select Office
                            </option>

                            {deliveryOffices &&
                              deliveryOffices.map((office) => (
                                <option
                                  key={office._id}
                                  value={office.officeName}
                                >
                                  {office.officeName}
                                </option>
                              ))}
                          </Form.Control>
                        </Form.Group>
                      </Col>

                      <Col sm={12} md={6} lg={6}>
                        <Form.Group controlId="deliveryOfficePayment">
                          <Form.Label style={{ color: "black" }}>
                            Delivery Office Payment
                          </Form.Label>
                          <Form.Control
                            // required
                            type="number"
                            placeholder="Delivery Office Payment"
                            value={deliveryOfficePayment}
                            onChange={(e) =>
                              setDeliveryOfficePayment(e.target.value)
                            }
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col sm={12} md={12} lg={12}>
                        <Form.Group controlId="status">
                          <Form.Label style={{ color: "black" }}>
                            Status
                          </Form.Label>
                          <Form.Control
                            required
                            as="select"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                          >
                            <option
                              value=""
                              disabled
                              style={{ color: "black" }}
                            >
                              Select Status
                            </option>
                            <option value="Pending">Pending</option>
                            <option value="Processing">Processing</option>
                            <option value="Completed">Completed</option>
                            <option value="Delivered">Delivered</option>
                            <option value="Returned">Returned</option>
                            <option value="Flight Completed">
                              Flight Completed
                            </option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mt-4">
                      <Col sm={12} md={12} lg={12} className="px-4">
                        <Row>
                          <Button
                            variant="outline-primary"
                            type="submit"
                            className="rounded"
                            style={{ fontWeight: "bold" }}
                          >
                            Create Passport
                          </Button>
                        </Row>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Form>
        )}
      </>
    </Container>
  );
};

export default CreatePassport;
